// antd v5 静态 message/notification 在 React 19 下会把 React root 挂在未连接的
// DocumentFragment 上，导致 message.success/warning 等 toast 不渲染。
// 这里把 holder 挂到 document.body 的真实节点上（等价官方 v5-patch-for-react-19），
// 需在应用入口最先引入。
import { createRoot } from "react-dom/client";
import { unstableSetRender } from "antd";

unstableSetRender((node, container) => {
  const host = document.createElement("div");
  document.body.appendChild(host);
  const root = createRoot(host);
  root.render(node);
  return async () => {
    root.unmount();
    host.remove();
  };
});